<div class="app-user-selection">
  <mat-form-field style="width: 100%">
    <mat-select [formControl]="userCtrl">
      <mat-option>
        <ngx-mat-select-search
          [formControl]="userFilteringCtrl"
          [searching]="searching"
          [placeholderLabel]="'Input name or phone number'"
          [noEntriesFoundLabel]="''"
          [disableScrollToActiveOnOptionsChanged]="true"
          [disableInitialFocus]="false"
          (focusin)="onFocus()"
        ></ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let user of filteredUsers | async" [value]="user">
        {{ user | PersonNamePipe }} - {{ user.phoneNumber | PhoneNumberPipe }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
